import Hero from './components/Hero';
import MarketingChallenge from './components/MarketingChallenge';
import MarketingPromise from './components/MarketingPromise';
import AICapabilities from './components/AICapabilities';
import KISolutions from './components/KISolutions';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-900">
      <Hero />
      <MarketingChallenge />
      <MarketingPromise />
      <AICapabilities />
      <KISolutions />
      <Contact />
      <Footer />
    </div>
  );
}
